module.exports = __webpack_public_path__ + "static/media/icon_potential_growth.7801beea.svg";